import {get, post} from '~/utils/request';

export function unionIDLogin(data) {
  return post('/Account/UnionIDLogin', data);
}

export function meLogin(data) {
  return get('/Account/GetMeLoginData', data);
}

export function hrLogin(data) {
  return get('/Account/GetHrLoginData', data);
}

export function logout(data) {
  return post('/Account/Logout', data);
}